import { TryRounded } from "@mui/icons-material"

export const domain = 'https://mfi-api.tis.coke.com'
export const azureClientId = 'd09388b2-aebc-4982-b7bd-cb81e241928b'
export const azureTenantId = '548d26ab-8caa-49e1-97c2-a1b1a06cc39c'
export const azureDomainHint = 'coca-cola.com'
export const apiKey = 'SyvAFAUua29HhpuJCtRRt7xwYNAIAp9o4hApYNLB'
export const stage = 'prod'
export const featureFlags = {
  communityHub: true,
  safetyHub: true,
  safetyHubBottler: true,
  safetyHubForum: true,
  safetyHubForumBottler: true,
  safetyHubPinning: true,
  safetyHubSettings: true,
  loginFlow: false,
  ownershipTargets: true,
  contactMgmtBottler: false,
  emailOptOut: true,
  communityHomePage: false,
}

export const SafetyHubSharepoint = {
  defaultImagePath: 'DefaultArticleThumbnail.jpg',
  "siteId": "groups.coca-cola.com,18f2d0a2-e373-4c4a-b16f-64378e8812b8,97aee8ed-13da-4c34-b177-8669a86b697c",
  domain: 'https://groups.coca-cola.com',
  baseSitePath: '/sites/NAOUQSE/safety',
  "urls": {
    "baseSite": "https://groups.coca-cola.com/sites/NAOUQSE/safety"
  },
  "listIds": {
    "pages": "c5c0d556-5f60-46f5-bba5-694c6c90122d",
    "documents": "914155ab-fed5-4741-95f2-59b6c88b9db6",
    "documentLibrary": "914155ab-fed5-4741-95f2-59b6c88b9db6"
  },
  "driveIds": {
    "SiteAssets": "b!otDyGHPjSkyxb2Q3jogSuO3orpfaEzRMsXeGaahraXymZnQfx16ERqn-_XDFqPE2",
    "documents": "b!otDyGHPjSkyxb2Q3jogSuO3orpfaEzRMsXeGaahraXyrVUGR1f5BR5XyWbbIi522",
    "Shared Documents": "b!otDyGHPjSkyxb2Q3jogSuO3orpfaEzRMsXeGaahraXyrVUGR1f5BR5XyWbbIi522",
  },
  "templateIds": {
    "news": "afb2be3c-def0-40b3-b8fb-d3873276c206"
  },
  vivaCommunity: {
    communityLinkPrefix: 'https://engage.cloud.microsoft/main/org/coca-cola.com/groups/',
    nonProdCommunityId: 'eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIyMjIyNDI2NzY3MzYifQ',
    communityId: 'eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIyMjIyNTIzNjc4NzIifQ'
  },
  settingsFilePath: 'Settings/HubSettings.json'
}